import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useAsyncCallback } from '../../../../hooks'
import { EntityAsyncMultiValuedInfiniteListMoreItems } from '../../../Entity'
import { MultiValuedList } from '../../../MultiValuedList'
import {
  UserMultiValuedListItem,
  UserMultiValuedListMoreItem,
} from '../../../User'
import { useDocFlowContext } from '../../DocFlow.hooks'
import { getDocFlowSendingFiles } from '../DocFlowSending.api'

import {
  getApiParams,
  getDataItems,
} from './DocFlowSendingValidationErrorsUserAsyncMultiValuedList.utils'

function DocFlowSendingValidationErrorsUserAsyncMultiValuedList({
  Item = UserMultiValuedListItem,
  MoreItem = UserMultiValuedListMoreItem,
  MoreItems = EntityAsyncMultiValuedInfiniteListMoreItems,
  errorId,
  ...restProps
}) {
  const { documentId } = useDocFlowContext()

  const handleLoadData = useAsyncCallback(
    params => getDocFlowSendingFiles({ data: params, documentId }),
    [documentId]
  )

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      MoreItems={MoreItems}
      moreItemsProps={{
        apiParams: getApiParams(errorId),
        getData: handleLoadData,
        getDataItems,
      }}
      moreProps={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.top,
      }}
    />
  )
}

export default DocFlowSendingValidationErrorsUserAsyncMultiValuedList
